export default "__VITE_ASSET__DstZ4cNH__"